<template>
  <div id="app">
    <component :is="layout">
      <router-view :key="$route.fullPath"></router-view>
    </component>
    <ChatFAB v-if="loggedIn"></ChatFAB>
    <div v-if="loading" class="loader">
      <img src="/static/images/svgs/loader.svg" alt="Loading..." />
    </div>
  </div>
</template>

<script>
const blank_layout = "blank";
import ChatFAB from "@/components/ChatFAB/index";
import { mapGetters } from "vuex";
export default {
  name: "App",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["loggedIn", "loading"]),
    layout() {
      var layout = (this.$route.meta.layout || blank_layout) + "-layout";
      return layout;
    }
  },

  components: { ChatFAB },
  beforeMount() {
    this.$store.dispatch("getUser");
  },

  mounted() {
    const rechargeRouteNames = [
      "water",
      "gas",
      "mobile",
      "postpaid",
      "electricity",
      "datacard",
      "dth"
    ];
    const findRouteName = rechargeRouteNames.find(routeName =>
      this.$route.fullPath.toLowerCase().indexOf(routeName) >= 0
        ? routeName
        : ""
    );
    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
      if (findRouteName) {
        window.location = `epaylater://${findRouteName}`;
      } else {
        window.location = `epaylater:/${this.$route.fullPath}`;
      }
      setTimeout(() => {
        this.$store
          .dispatch("signup_status")
          .then(response => {
            this.$store.commit("setLoginState", true);
            this.$store
              .dispatch("resolveSignupRoute", response.userSignupStatus)
              .then(response => {
                if (!this.$route.meta.requiresAuth) {
                  this.$router.push({
                    name: response.routeName,
                    query: { redirect: this.$route.query.redirect || "/" }
                  });
                }
              })
              .catch(() => {
                this.$router.push({ name: "Signup" });
              });
          })
          .catch(err => {
            if (this.$route.name !== "Signup" && this.$route.name !== "Login") {
              this.$router.push({
                name: "Signup",
                query: { redirect: this.$route.query.redirect || "/" }
              });
            }
          });
      }, 25);
    } else {
      this.$store
        .dispatch("signup_status")
        .then(response =>
          this.$store
            .dispatch("resolveSignupRoute", response.userSignupStatus)
            .then(response => {
              if (!this.$route.meta.requiresAuth) {
                if (response.routeName === "Loading") {
                  this.$store.commit("setLoginState", true);
                  this.$store.dispatch("getUser").then(response => {
                    response.version === "epaylaterv2"
                      ? this.$router.push({ name: "Dashboard" })
                      : this.$router.push({ name: "Home" });
                  });
                } else {
                  this.$router.push({ name: response.routeName });
                }
              }
            })
            .catch(() => this.$router.push({ name: "Signup" }))
        )
        .catch(err => {
          if (this.$route.name !== "Signup" && this.$route.name !== "Login") {
            this.$router.push({
              name: "Signup",
              query: { redirect: this.$route.query.redirect || "/" }
            });
          }
        });
    }
  },
  watch: {},
  methods: {}
};
</script>

<style lang="css">
@import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

body {
  font-family: "Overpass", sans-serif;
}
</style>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Overpass:300,400,600");
@import "assets/sass/variables";
@import "assets/sass/custom";

* {
  font-family: "Overpass";
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

input[type="number"] {
  appearance: textfield; /* Firefox */
}
.NikiSDK-FrameWrapper.NikiSDK-hanging {
  right: 0 !important;
  left: 15px !important;
}
:root {
  --primary-color: #3582fd;
  --white: #fff;
  --gray-1: #979797;
  --gray-2: #4d4d4d;
  --gray-3: #79899f;
  --gray-4: #d5d5d5;
  --gray-5: #f6f6f6;
  --gray-6: #575757;
  --gray-7: #757575;
  --gray-8: #fafafa;
  --gray-9: #7d7d7d;
  --gray-10: #d8d8d8;
  --gray-11: #b7b7b7;
  --gray-12: #f9f9f9;
  --green: #5ab45c;
  --red: #db594e;
  --error: #e02020;
  --success: #6dd400;
}
.grecaptcha-badge {
  visibility: hidden;
}
@media screen and (max-width: $md) {
  #lc_chat_layout {
    display: none !important;
  }
}

.loader {
  z-index: 9999999;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: block;
    width: 36px;
    height: 36px;
  }
}

#page-wrap {
  @media screen and (max-width: $md) {
    min-height: 100vh;
  }
  @media screen and (min-width: $sm) {
    background: #f5f6f7;
  }
  .no-data {
    padding-top: 20px;
    padding-bottom: 20px;
    font-family: Overpass;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.2px;
    text-align: center;
    color: #b0bfd9;
  }
  button,
  button:hover,
  button:focus,
  button:active {
    outline: none;
    box-shadow: none;
  }
  .content-wrap {
    position: relative;
    z-index: 999;
  }
  .back-link {
    display: block;
  }
  .btn {
    border-radius: 50px;
    border: none;
    font-size: 16px;

    &-blue {
      background-color: #377cfd;
      color: var(--white);
    }
  }

  a {
    text-decoration: none;
    &:hover,
    &:active,
    &:visited {
      text-decoration: none;
    }
  }
  @media screen and (min-width: $sm) {
    .content-wrap {
      /* z-index: 900; */
      z-index: 8;
      padding-top: 40px;
      padding-bottom: 40px;
    }
  }
}
.signup {
  &__text-field {
    box-shadow: none;
    border: none;
    border-bottom: solid 0.06rem var(--gray-4);
    display: block;
    padding-bottom: 0.5rem;
    font-size: 1.8rem;
    color: var(--gray-2);
    width: 100%;
    outline: none;
    &--pan {
      text-transform: uppercase;
    }
    &::placeholder {
      font-size: 1.6rem;
      color: var(--gray-7);
      text-transform: initial;
    }
    &:focus {
      border-bottom: solid 0.06rem var(--primary-color);
      &:invalid {
        border-bottom: solid 0.06rem var(--error);
      }
    }
    &:valid {
      border-bottom: solid 0.06rem var(--primary-color);
    }
    &--date {
      background: url(../static/images/noun_Calendar_2647842.svg) no-repeat
        scroll 0.7rem 0.7rem;
      background-position: right;
      color: var(--gray-2);
      padding-right: 3rem;
    }
  }
}
.material-textfield {
  margin-top: 4rem;
  width: 100%;
  &__input {
    background: none;
    border: none;
    display: block;
    font-size: 1.8rem;
    padding: 0.25rem 0.1rem;
    border-bottom: solid 0.06rem var(--gray-4);
    color: var(--gray-2);
    width: 100%;
    &--pan {
      text-transform: uppercase;
    }
    &:invalid {
      box-shadow: none;
      & ~ .material-textfield__label {
        &::before {
          font-size: 1.8rem;
          top: -3rem;
        }
      }
    }
    &:focus {
      outline: none;
      & ~ .material-textfield__label::after {
        left: 0%;
        width: 100%;
      }
    }
    &[required]:focus {
      & ~ .material-textfield__label::before {
        font-size: 1.4rem;
        top: -5rem;
        color: var(--gray-7);
      }
    }
  }
  &--dirty {
    .material-textfield__input {
      &:invalid {
        border-bottom: solid 0.06rem var(--error);
      }
      &:valid {
        border-bottom: solid 0.06rem var(--primary-color);
      }
      & ~ .material-textfield__label::before {
        font-size: 1.4rem;
        top: -5rem;
        color: var(--gray-7);
      }
      &:invalid ~ .material-textfield__label::before {
        color: var(--error);
      }
      &:valid ~ .material-textfield__label::before {
        color: var(--primary-color);
      }
    }
  }
  &__label {
    display: inline-block;
    font-size: 0;
    pointer-events: none;
    position: absolute;
    text-transform: capitalize;
    margin-bottom: unset;
    font-weight: normal;
    &::before {
      content: attr(data-content);
      position: relative;
      transition: all 0.2s ease;
      will-change: font-size, top;
      font-size: 1.4rem;
      top: -5rem;
      color: #b0bfd9;
    }
    &::after {
      bottom: 0.9rem;
      content: "";
      height: 0.3rem;
      left: 50%;
      position: absolute;
      transition: all 0.2s ease;
      width: 0;
      will-change: width, left;
    }
  }
}
.no-underline {
  &:hover {
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue